import {
  SignInButton,
  UserButton,
  useAuth,
} from "@clerk/clerk-react";

/**
 * Renders sign-in button (anonymous) or user avatar (signed in).
 * Uses modal mode so the user never leaves the current drawing.
 */
export const UserMenu = () => {
  const { isSignedIn, isLoaded } = useAuth();

  // If Clerk hasn't loaded yet, render nothing (canvas still works)
  if (!isLoaded) {
    return null;
  }

  if (isSignedIn) {
    return (
      <div className="simpledraw-user-menu" style={{ marginRight: 8 }}>
        <UserButton
          afterSignOutUrl={window.location.origin}
          appearance={{
            elements: {
              avatarBox: { width: 28, height: 28 },
            },
          }}
        />
      </div>
    );
  }

  return (
    <div className="simpledraw-user-menu" style={{ marginRight: 8 }}>
      <SignInButton mode="modal">
        <button
          className="simpledraw-sign-in-btn"
          style={{
            background: "var(--color-primary)",
            color: "var(--color-primary-contrast)",
            border: "none",
            borderRadius: 6,
            padding: "4px 12px",
            fontSize: 13,
            cursor: "pointer",
            fontWeight: 500,
          }}
        >
          Sign in
        </button>
      </SignInButton>
    </div>
  );
};
